import { Base } from 'layouts'
import { IndustryList } from 'components'

import * as S from './styled'

export function Industry() {
  return (
    <Base>
      <S.GridContainer container>
        <IndustryList />
      </S.GridContainer>
    </Base>
  )
}
